export const DOMAIN_PHASE_LABELS: Record<string, string> = {
  setup: '게임 준비',
  mission_draft: '미션 드래프트',
  round_roll: '주사위 굴리기',
  mission_select: '미션 선택',
  betting: '베팅',
  draft: '주사위 배치',
  settlement: '정산',
  final_score: '최종 점수',
  game_over: '게임 종료',
};
